<!-- src/App.vue -->
<template>
  <div id="app" :class="{ 'layout-full': !isUserAuthenticated }">
    <!-- الشريط الجانبي يظهر فقط إذا كان المستخدم مسجلاً -->
    <!-- <Sidebar 
      v-if="isUserAuthenticated" 
      :user="currentUser" 
      @logout="handleLogout" 
    /> -->
    
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import auth from './services/auth.js';
import Sidebar from './components/Sidebar.vue'; // استيراد المكون الجديد
import { messaging, getToken, onMessage } from '@/firebase';
import Swal from 'sweetalert2'; 
import api from './api/axios.js';
export default {
  name: 'App',
  components: {
    Sidebar // تسجيل المكون الجديد
  },
  data() {
    return {
      isUserAuthenticated: false,
      currentUser: null,
   notificationSound: new Audio('/sound/notification.mp3')
    };
  },

  mounted() {
    if (auth.isAuthenticated()) {
         this.requestPermission();
        }
           this.listenForeground();
  },
  methods: {
     async requestPermission() {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          
          // هنا نستخدم VAPID Key الذي حصلنا عليه من Console -> Cloud Messaging
          const token = await getToken(messaging, {
            vapidKey: "BG4vPEp94zgnSKeU1Q1vzmx1JsYz8o_b67qnvmOY2Qcyvu0LWCHXji6HM00NdadbR3q5Y9acE7dISU_jnvoDCgE" 
          });

          if (token) {
            console.log('FCM Token:', token);
            // إرسال التوكن للباك إند لحفظه
            await api.post('/save-fcm-token', { token });
          }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },

    listenForeground() {
      // الاستماع للرسائل أثناء فتح التطبيق
      onMessage(messaging, (payload) => {
         Swal.fire({
          title: payload.notification.title,
          text: payload.notification.body,
          icon: 'info',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true
        });
        
        // تشغيل صوت تنبيه (اختياري)
         this.playAudio();
      
      });
    },
 playAudio() {
      // إعادة الصوت للبداية (في حال وصلت رسائل متتالية)
      this.notificationSound.currentTime = 0;

      // محاولة التشغيل
      var playPromise = this.notificationSound.play();

      if (playPromise !== undefined) {
        playPromise.then(_ => {
          // تم التشغيل بنجاح
          console.log("Audio played");
        })
        .catch(error => {
          // 3. منع ظهور الخطأ الأحمر في الكونسول
          console.warn("تعذر تشغيل الصوت تلقائياً (يتطلب تفاعل المستخدم):", error);
        });
      }
    },
    handleLogout() {
      auth.logout();
      this.updateAuthState();
      this.$router.push({ name: 'Home' }).catch(()=>{});
    },
    // دالة مركزية لتحديث حالة المصادقة وبيانات المستخدم
    updateAuthState() {
        console.log(auth.isAuthenticated());
        
        this.isUserAuthenticated = auth.isAuthenticated();
        this.currentUser = auth.getUser();
    }
  },
  watch: {
    // مراقبة تغيير المسار لتحديث الحالة (مهم عند تحديث الصفحة أو التنقل)
    '$route'() {
        this.updateAuthState();
    }
  },
  created() {
    // تحديث الحالة عند إنشاء التطبيق لأول مرة
    this.updateAuthState();
  }
};
</script>

<style>
/* تنسيقات عامة للتطبيق */
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css');

body {
  font-family: 'Cairo', sans-serif;
  direction: rtl;
  background-color: #f8f9fa;
  margin: 0;
  color: #212529;
}

/* #app {
  display: flex;
} */

.main-content {
  flex-grow: 1;
  /* padding: 2rem; */
  /* margin-right: 260px; ترك مساحة للشريط الجانبي */
  transition: margin-right 0.3s ease;
}

/* عندما لا يكون هناك شريط جانبي (صفحة تسجيل الدخول) */
#app.layout-full .main-content {
  margin-right: 0;
}
</style>